import { render, staticRenderFns } from "./PinflInput.vue?vue&type=template&id=6c80ebca&scoped=true&"
import script from "./PinflInput.vue?vue&type=script&lang=js&"
export * from "./PinflInput.vue?vue&type=script&lang=js&"
import style0 from "./PinflInput.vue?vue&type=style&index=0&id=6c80ebca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c80ebca",
  null
  
)

export default component.exports